import React from 'react';
import styles from './DropMenu.module.css'
import {useNavigate} from "react-router-dom";
import {IProfileMenu} from "../../../../../models/IProfileMenu";

type IProps = {
    menuData: IProfileMenu[]
}
const DropMenu = ({menuData}: IProps) => {

    const navigate = useNavigate()

    return (
        <div className={styles.dropMenuWrapper}>

            {menuData.map(({title, path, callback}, index) => {
                return (
                    <div key={`profileMenu_${index}`} className={styles.dropMenuSection} onClick={() => {
                        if (path) {
                            navigate(path)
                        } else if (callback) {
                            callback()
                        }
                    }}>
                        <span className={styles.dropMenuItem}>{title}</span>
                    </div>
                )
            })}


        </div>
    );
};

export default DropMenu;